import { useEffect, useState } from "react";
import Layout from '../../layout/default';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { Button, Breadcrumb, Form } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { useApiClient } from "../../ApiService/useApiClient";
import { jsPDF } from "jspdf"; 
import autoTable from "jspdf-autotable"; 

export const CustomerIncidentReport = () => {
    const api = useApiClient();

    const [data, setData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        CustomerID: '',
        FromDate: '',
        ToDate: ''
    });

    const columns = [
        {
            name: 'Incident Date',
            selector: row => row.incidentDate ? new Date(row.incidentDate).toLocaleDateString() : '',
            sortable: true,
        },
        {
            name: 'Incident Name',
            selector: row => row.incidentName || '',
            sortable: true,
        },
        {
            name: 'Details',
            selector: row => row.incidentDetail || '',
            sortable: false,
            wrap: true,
        },
        {
            name: 'Actions',
            selector: row => row.incidentActions || '',
            sortable: false,
            wrap: true,
        },
        {
            name: 'Reported By',
            selector: row => row.incidentReportedBy || '',
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.incidentStatus || '',
            sortable: true,
        },
        {
            name: 'Closed Date',
            selector: row => row.incidentClosedDate ? new Date(row.incidentClosedDate).toLocaleDateString() : '',
            sortable: true,
        },
        {
            name: 'Last Updated',
            selector: row => row.incidentLastUpdated ? new Date(row.incidentLastUpdated).toLocaleDateString() : '',
            sortable: true,
        },
    ];

    useEffect(() => {
        // Fetch customers list
        api.get("HMCareData/customerlist/")
            .then(res => {
                setCustomerList(res.data);
            })
            .catch(err => {
                console.error("Error fetching customers", err);
            });
    }, []);

    const fetchData = () => {
        setError(null);
        setLoading(true);

        if (!params.CustomerID) {
            setError(new Error("Please select a Customer."));
            setLoading(false);
            return;
        }

        // Construct API URL with query params for filtering by date if API supports it
        // Assuming your API supports query params like fromDate, toDate
        let apiUrl = `CustomerIncident/incidentlist/${params.CustomerID}`;
        const queryParams = [];
        if (params.FromDate) queryParams.push(`fromDate=${params.FromDate}`);
        if (params.ToDate) queryParams.push(`toDate=${params.ToDate}`);
        if (queryParams.length > 0) apiUrl += '?' + queryParams.join('&');

        api.get(apiUrl)
            .then(response => {
                setData(response.data || []);                
                setLoading(false);
                //console.log(response.data || []);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    };


    const generatePDF = () => {
    const doc = new jsPDF();
    const marginLeft = 14;
    let currentY = 20;

    doc.setFontSize(18);
    doc.text("Customer Incident History Report", marginLeft, currentY);
    currentY += 10;

    const customer = customerList.find(c => c.customerid === params.CustomerID);
    const customerName = customer ? customer.name : "Unknown Customer";

    doc.setFontSize(12);
    doc.text(`Client: ${customerName}`, marginLeft, currentY);
    currentY += 8;

    let dateRangeText = "All Dates";
    if (params.FromDate && params.ToDate) {
        dateRangeText = `From ${new Date(params.FromDate).toLocaleDateString()} to ${new Date(params.ToDate).toLocaleDateString()}`;
    } else if (params.FromDate) {
        dateRangeText = `From ${new Date(params.FromDate).toLocaleDateString()}`;
    } else if (params.ToDate) {
        dateRangeText = `Up to ${new Date(params.ToDate).toLocaleDateString()}`;
    }
    doc.text(`Date Range: ${dateRangeText}`, marginLeft, currentY);
    currentY += 8;

    const reportDate = new Date().toLocaleString();
    doc.text(`Report Date: ${reportDate}`, marginLeft, currentY);
    currentY += 10;

    doc.setFontSize(11);

    data.forEach((incident, index) => {
        // Add page if reaching bottom
        if (currentY > 270) {
            doc.addPage();
            currentY = 20;
        }

        // Header row with background
        doc.setFillColor(240, 244, 248); // Light blue/gray
        doc.rect(marginLeft - 2, currentY - 5, 180, 10, 'F');
        doc.setFont(undefined, 'bold');
        doc.text(`${incident.incidentName || 'Unnamed Incident'}`, marginLeft, currentY);
        doc.setFont(undefined, 'normal');
        doc.text(`${incident.incidentDate ? new Date(incident.incidentDate).toLocaleDateString() : '—'}`, 180, currentY, { align: 'right' });
        currentY += 8;

        const addField = (label, value) => {
            doc.setFont(undefined, 'bold');
            doc.text(`${label}:`, marginLeft, currentY);
            currentY += 6;
            doc.setFont(undefined, 'normal');
            const splitText = doc.splitTextToSize(value || '—', 180 - marginLeft * 2);
            doc.text(splitText, marginLeft + 5, currentY);
            currentY += splitText.length * 6 + 2;
        };

        addField("Incident Details", incident.incidentDetail);
        addField("Actions Taken", incident.incidentActions);
        addField("Reported By", incident.incidentReportedBy);
        addField("Status", incident.incidentStatus);
        addField("Closed Date", incident.incidentClosedDate ? new Date(incident.incidentClosedDate).toLocaleDateString() : '—');
        addField("Last Updated", incident.incidentLastUpdated ? new Date(incident.incidentLastUpdated).toLocaleDateString() : '—');

        currentY += 4; // Space between incidents
    });

    // Page footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });
    }

    doc.save("Customer_Incident_History_Report.pdf");
};


    // const generatePDF = () => {
    //     const doc = new jsPDF();

    //     doc.setFontSize(18);
    //     doc.text("Customer Incident History Report", 14, 22);

    //     // Get selected customer name
    //     const customer = customerList.find(c => c.customerid === params.CustomerID);
    //     const customerName = customer ? customer.name : "Unknown Customer";

    //     doc.setFontSize(12);
    //     doc.text(`Client: ${customerName}`, 14, 30);

    //     // Date range text
    //     let dateRangeText = "All Dates";
    //     if (params.FromDate && params.ToDate) {
    //         dateRangeText = `From ${new Date(params.FromDate).toLocaleDateString()} to ${new Date(params.ToDate).toLocaleDateString()}`;
    //     } else if (params.FromDate) {
    //         dateRangeText = `From ${new Date(params.FromDate).toLocaleDateString()}`;
    //     } else if (params.ToDate) {
    //         dateRangeText = `Up to ${new Date(params.ToDate).toLocaleDateString()}`;
    //     }
    //     doc.text(`Date Range: ${dateRangeText}`, 14, 38);

    //     // Report printed date
    //     const reportDate = new Date().toLocaleString();
    //     doc.text(`Report Date: ${reportDate}`, 14, 46);

    //     // Table columns for PDF
    //     const tableColumn = [
    //         "Incident Date",
    //         "Incident Name",
    //         "Details",
    //         "Actions",
    //         "Reported By",
    //         "Status",
    //         "Closed Date",
    //         "Last Updated"
    //     ];

    //     // Map data for PDF table
    //     const tableRows = data.map(row => [
    //         row.incidentDate ? new Date(row.incidentDate).toLocaleDateString() : '',
    //         row.incidentName || '',
    //         row.incidentDetail || '',
    //         row.incidentActions || '',
    //         row.incidentReportedBy || '',
    //         row.incidentStatus || '',
    //         row.incidentClosedDate ? new Date(row.incidentClosedDate).toLocaleDateString() : '',
    //         row.incidentLastUpdated ? new Date(row.incidentLastUpdated).toLocaleDateString() : ''
    //     ]);

    //     autoTable(doc, {
    //         head: [tableColumn],
    //         body: tableRows,
    //         startY: 54,
    //         theme: 'striped',
    //         styles: { fontSize: 9, cellPadding: 2 },
    //         columnStyles: {
    //             2: { cellWidth: 50 }, // wider for details
    //             3: { cellWidth: 50 }, // wider for actions
    //         },
    //         didDrawPage: (dataArg) => {
    //             const pageCount = doc.internal.getNumberOfPages();
    //             const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
    //             const pageText = `Page ${pageNumber} of ${pageCount}`;
    //             doc.setFontSize(10);
    //             doc.text(pageText, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 10, { align: 'center' });
    //         }
    //     });

    //     doc.save("Customer_Incident_History_Report.pdf");
    // };

    return (
        <Layout title="Customer Incident History" content="container">
            <Breadcrumb className="breadcrumb-arrow">
                <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>
                <Breadcrumb.Item active>Customer Incident History</Breadcrumb.Item>
            </Breadcrumb>

            <div style={{ padding: '20px' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '10px',
                        alignItems: 'end',
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        marginBottom: '20px',
                        maxHeight: 'fit-content',
                    }}
                >
                    <Form.Group controlId="CustomerID">
                        <Form.Label>Customer</Form.Label>
                        <Form.Select
                            value={params.CustomerID}
                            onChange={e => setParams(p => ({ ...p, CustomerID: e.target.value }))}
                        >
                            <option value="">Select Customer</option>
                            {customerList.map(customer => (
                                <option key={customer.customerid} value={customer.customerid}>
                                    {customer.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group controlId="FromDate">
                        <Form.Label>From</Form.Label>
                        <Form.Control
                            type="date"
                            value={params.FromDate}
                            onChange={e => setParams(p => ({ ...p, FromDate: e.target.value }))}
                        />
                    </Form.Group>

                    <Form.Group controlId="ToDate">
                        <Form.Label>To</Form.Label>
                        <Form.Control
                            type="date"
                            value={params.ToDate}
                            onChange={e => setParams(p => ({ ...p, ToDate: e.target.value }))}
                        />
                    </Form.Group>

                    <div style={{ alignSelf: 'end' }}>
                        <Button
                            variant="outline-primary"
                            onClick={fetchData}
                            style={{ width: '100%' }}
                            disabled={loading}
                        >
                            {loading ? "Running" : "Run Report"}
                        </Button>
                    </div>

                    <div style={{ alignSelf: 'end' }}>
                        <Button
                            variant="outline-secondary"
                            onClick={generatePDF}
                            disabled={data.length === 0}
                            style={{ height: '40px', minWidth: '150px' }}
                        >
                            Print Report
                        </Button>
                    </div>
                </div>

                {error && (
                    <div className="alert alert-danger" role="alert" style={{ marginBottom: '15px' }}>
                        {error.message}
                    </div>
                )}

                {loading && <Spinner animation="border" variant="primary" />}

                {/* {data && data.length > 0 && (
                    <DataTable
                        columns={columns}
                        data={data}
                        striped
                        pagination
                        highlightOnHover
                        dense
                        persistTableHead
                    />
                )} */}

               {data && data.length > 0 && (
    <div className="incident-cards-container" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {data.map((incident, index) => (
            <div key={index} className="incident-card" style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '0',
                overflow: 'hidden',
                backgroundColor: '#fff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
            }}>
                {/* Header Row */}
                <div style={{
                    backgroundColor: '#f0f4f8',
                    padding: '10px 15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #ddd'
                }}>
                    <strong>{incident.incidentName || 'Unnamed Incident'}</strong>
                    <span style={{ fontSize: '0.9em', color: '#555' }}>
                        {incident.incidentDate ? new Date(incident.incidentDate).toLocaleDateString() : '—'}
                    </span>
                </div>

                {/* Body */}
                <div style={{ padding: '12px 15px', lineHeight: '1' }}>
                    <p><strong>Incident Date:</strong> {incident.incidentDate ? new Date(incident.incidentDate).toLocaleDateString() : '—'} </p>
                    {/* <p><strong>Incident Details:</strong> {incident.incidentDetail || '—'}</p>
                    <p><strong>Actions Taken:</strong> {incident.incidentActions || '—'}</p> */}

                    <div style={{ marginBottom: '12px' }}>
                        <strong>Incident Details:</strong>
                        <div style={{ marginLeft: '10px', whiteSpace: 'pre-wrap' }}>
                            {incident.incidentDetail || '—'}
                        </div>
                    </div>
                    <div style={{ marginBottom: '12px' }}>
                        <strong>Actions Taken:</strong>
                        <div style={{ marginLeft: '10px', whiteSpace: 'pre-wrap' }}>
                            {incident.incidentActions || '—'}
                        </div>
                    </div>


                    <p><strong>Reported By:</strong> {incident.incidentReportedBy || '—'}</p>
                    <p><strong>Status:</strong> {incident.incidentStatus || '—'}</p>
                    <p><strong>Closed Date:</strong> {incident.incidentClosedDate ? new Date(incident.incidentClosedDate).toLocaleDateString() : '—'}</p>
                    <p><strong>Last Updated:</strong> {incident.incidentLastUpdated ? new Date(incident.incidentLastUpdated).toLocaleDateString() : '—'}</p>
                </div>
            </div>
        ))}
    </div>
)}



            </div>
        </Layout>
    );
};
